// http://pd.m.com/#id=rqqbgo&p=%E7%AD%89%E7%BA%A7%E6%A0%87%E8%AF%86%E6%98%BE%E7%A4%BA%E8%B0%83%E6%95%B4&g=1

const msgCommon = [
  { key: 'new', desc: '新人标识' },
  { key: 'honour_fans', desc: '荣耀粉丝' },
  { key: 'operator', desc: '运营/代理 官方' },
  { key: 'star_level', desc: '明星/主播等级' },
  { key: 'guild', desc: '公会标识' },
  { key: 'admin', desc: '管理' },
  { key: 'cost_level', desc: '本场消费等级' },
  { key: 'guard', desc: '真爱守护' },
  // { key: 'noble_level', desc: '贵族等级' },
  // { key: 'super_noble', desc: '超级贵族' },
  // { key: 'star_vip_level', desc: '星钻会员' },
  {
    key: 'level',
    desc: '【数字等级、富豪/用户等级、新人标识】/【明星/主播等级】',
    params: {
      user: [
        { key: 'pay_level', desc: '充值等级' },
        { key: 'rich_level', desc: '富豪/用户等级' },
        { key: 'week_spend_level', desc: '闪星' },
      ],
      star: [{ key: 'star_level', desc: '明星/主播等级' }],
    },
  },
  { key: 'mm_no', desc: '靓号' },
  { key: 'enter_name', desc: '进场称号' },
  { key: 'vip', desc: 'VIP标识' },
  { key: 'family', desc: '家族徽章' },
];

// 神秘人
const mystic = [{ key: 'mystic', desc: '神秘人' }];

// 进场消息
const msgEnter = [
  'new',
  'app_type',
  'lucky_star',
  'honour_fans',
  'operator',
  'guild',
  'admin',
  'cost_level',
  'guard',
  'pay_level',
  'mm_no',
  'rich_level',
  'family',
];

// 当前房间主播的
const msgRoomOwner = ['star_level', 'mm_no', 'family'];

// 公屏发言
const msgChat = [
  'new',
  'app_type',
  'lucky_star',
  'honour_fans',
  'operator',
  'star_level',
  'guild',
  'admin',
  'cost_level',
  'guard',
  'pay_level',
  'medal',
  'mm_no',
  'rich_level',
  'week_spend_level',
  'family',
  'enter_name',
];

// 设置为管理、取消管理
const msgAdmin = ['new', 'pay_level', 'rich_level', 'week_spend_level'];

// 礼物消息
const msgGift = [
  'new',
  'lucky_star',
  'honour_fans',
  'operator',
  'star_level',
  'guild',
  'admin',
  'cost_level',
  'guard',
  'pay_level',
  'mm_no',
  'rich_level',
  'week_spend_level',
  'family',
];

// 特权推荐
const recommend = [
  'new',
  'honour_fans',
  'operator',
  'star_level',
  'guild',
  'admin',
  'cost_level',
  'guard',
  'pay_level',
  'mm_no',
  'rich_level',
];

// 在线观众列表
const userList = [
  'new',
  'app_type',
  'honour_fans',
  'operator',
  'guild',
  'admin',
  'guard',
  'pay_level',
  'mm_no',
  'rich_level',
];

// 新用户列表
const newUserList = [
  'new',
  'app_type',
  'honour_fans',
  'operator',
  'guild',
  'admin',
  'guard',
  'pay_level',
  'mm_no',
  'rich_level',
];

// 支持榜
const supportList = [
  'new',
  'honour_fans',
  'operator',
  'guild',
  'admin',
  'guard',
  'pay_level',
  'rich_level',
];

// 管理列表

const adminList = ['honour_fans', 'admin', 'pay_level', 'rich_level'];

const userMenu = ['new', 'rich_level', 'week_spend_level', 'guard', 'pay_level'];

export default {
  msgEnter,
  msgRoomOwner,
  msgCommon,
  mystic,
  msgGift,
  msgChat,
  recommend,
  msgAdmin,
  supportList,
  userList,
  newUserList,
  adminList,
  userMenu,
};
